import { CONSULT } from './constants/consult_c';
import _u from './util';
import _v from './vars';
import _t from './templates/templates_t';
import _ from 'lodash';

function getConsultWidg() {
    if (typeof userHpId != 'undefined' && userHpId != '' && !isNaN(Number(userHpId))) {
        let value = _.filter(CONSULT, {
            'userHpId': userHpId
        });

        let ulPosts = document.getElementById('postList');
        ulPosts != null ? ulPosts.innerHTML = '' : '';

        if (ulPosts != null) {
            var headerandDataObject = {
                method: 'POST',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json; charset=utf-8'
                },
                body: '{"tags": "' + encodeURIComponent(value[0].consultTag) + '", "query": "' + encodeURIComponent(value[0].consultTag) + '", "pageSize":6, "sortBy": "date", "sortOrder": "Descending"}'
            }

            _u.apiPost('https://www.' + _u.getDomain() + 'medscape.com/api/v1/consultservice/consultrelatedlinks', headerandDataObject).then(data => {
                if (typeof data != 'undefined' && typeof data.data != 'undefined') {
                    let posts = [];
                    posts = data.data.Items;

                    if (posts.length > 0) {
                        let ulConsultHeader = document.getElementById('pers-consult-subheader');
                        ulConsultHeader.innerText = value[0].text;

                        document.getElementById('consult-widget').classList.add("active");
                        posts.forEach((element, index) => {
                            if (element.Tags.toLowerCase().match(/(^adverse drug reaction ?,)|(, ?adverse drug reaction ?,)|(, ?adverse drug reaction ?$)/) == null && element.Tags.toLowerCase().match(/(^suppress ?,)|(, ?suppress ?,)|(, ?suppress ?$)/) == null) {
                                if (index > 2) {
                                    return;
                                }
                                let postObject = {};
                                postObject.uri = 'https://www.' + _u.getDomain() + 'medscape.com/consult/post?id=' + element.Id;
                                postObject.imageUrl = element.Author.AvatarUrl;
                                postObject.displayName = element.Author.DisplayName;
                                postObject.body = element.Title;
                                postObject.repliesCount = element.ReplyCount;
                                ulPosts.appendChild(_u.strToDom(_t.consultItem(postObject)));
                            }
                        });

                        var li = document.getElementsByClassName("pers-posts-item");

                        li.length === 0 ? document.getElementById('consult-widget').classList.remove("active") : '';

                        for (var i = 0; i < li.length; i++) {
                            li[i].addEventListener("click", (e) => {
                                let target = _u.getEventTarget(e);
                                let li = target.closest('li');
                                let newnode = [];
                                li.closest('ul').children.forEach(element => {
                                    newnode.push(element);
                                });
                                let index = newnode.indexOf(li);

                                wmdPageLink('fy-rr_cst' + (index + 1).toString(), this);
                            });
                        }
                    }
                }
            }).catch((error) => {
                console.log(error);
            });
        }
    }
}

export default getConsultWidg;